import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["headerContent"]

  closeSidebar() {
    this.element.classList.remove("sidebar-mobile-open")
  }

  toggleHeader() {
    if (this.hasHeaderContentTarget) {
      this.headerContentTarget.classList.toggle("header-mobile-open")
    }
  }

  toggleSidebar() {
    this.element.classList.toggle("sidebar-mobile-open")
  }
}
